import StarkRwaeMarketplace from './StarkRwaeMarketplace';
import seedData from './Stark_RWAE_Exchange_Seed_Data.json';

export default function App() {
  return <StarkRwaeMarketplace seedData={seedData} />;
}
